import { combineReducers } from "redux";
import authReducers from "./AuthReducers";
import { CMSReducers } from "./CMSReducrs";
import ContestsReducers from "./ContestsReducers";
import FootballReducer from "./FootballReducers";
import MatchReducers from "./MatchReducers";
import { FantasyPointsReducers } from "./PointsManagementReducer";
import SeriesReducers from "./SeriesReducer";
import UsersReducers from "./UsersReducers";
import { TeamManagerReducers } from "./TeamManagerReducers";
import { PlayerManagerReducers } from "./PlayerManagerReducers";
import { BannerManagementReducers } from "./BannerManagementReducers"
import { StateReducers } from "./StateReducers"
import { SeriesManagerReducers } from "./SeriesManagerReducers"
import { TransactionManagementReducers } from "./TransactionManagementReducers";
import { SettingsReducers } from "./SettingsReducers";
import { AccumulatorReducers } from "./AccumulatorReducers"
import { DashboardReducrs } from "./DashboardReducrs"
import { SubadminReducrs } from "./SubadminReducrs"
import { NotifyReducers } from "./NotificationReducers";
import { ReportManagementReducers } from "./ReportManagementReducers";

export default combineReducers({
    dashboard: DashboardReducrs,
    auth: authReducers,
    users: UsersReducers,
    contests: ContestsReducers,
    matches: MatchReducers,
    football: FootballReducer,
    series: SeriesReducers,
    points: FantasyPointsReducers,
    cms: CMSReducers,
    team_manager: TeamManagerReducers,
    player_manager: PlayerManagerReducers,
    series_manager: SeriesManagerReducers,
    banner_manager: BannerManagementReducers,
    transaction_manager: TransactionManagementReducers,
    states: StateReducers,
    settings: SettingsReducers,
    accumulator: AccumulatorReducers,
    subAdmin: SubadminReducrs,
    notification: NotifyReducers,
    reports:ReportManagementReducers
})